import { getLogger } from '@loanmarket/logger-core';

export const catchError = (e, section = 'Generic Log') => {
  const logger = getLogger(section);
  logger.error(`${section} : ${e.message}`);
};
